// Dependencies
import React, {Component} from "react";
import {withRouter, RouteComponentProps} from "react-router-dom";
import {connect} from "react-redux";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {TransitionGroup, CSSTransition} from "react-transition-group";
import {cloneDeep} from "lodash";

import "./SpecialPrizesPresetConfiguration.component.scss"

//Utils
import FormSelect from "../../../../utils/forms/components/FormSelect";
import Form from "../../../../utils/forms/components/Form";
import {SubsidiaryUtils} from "../../../../utils/Subsidiary/SubsidiaryUtils";
import {Dialog} from "../../../../utils/Dialog/Dialog.component";

//Components
import {Subsidiary} from "../../../halls/types/subsidiaries";
import {pigBoomFields} from "./Schemas/PigBoomSchemas";
import {mrChampionFields} from "./Schemas/MrChampionSchemas";

import {baseConfigInitialFields} from "./Schemas/SpecialPrizesPresetSchemas"
//Actions
import {ActionCreator} from "../../../../actions/actions";
import {SpecialPrizesPresetsActionCreators} from "../../actions/actionCreators";

//Store
import {specialPrizesPresetsStoreSelectors} from "../../store/store";


export interface SpecialPrizesPresetConfigurationProps extends RouteComponentProps {
    getSubsidiaries: ActionCreator;
    subsidiariesList: Subsidiary[];
    subsidiariesLoading: boolean;
    getPreset: ActionCreator;
    presetLoading: boolean;
    initialPreset: any;
    addPreset: ActionCreator;
    submittingPresetState: any;
    submitPresetLoading: boolean;
    clearPreset: ActionCreator;
    clearSubmitPreset: ActionCreator;
}

export interface SpecialPrizesPresetConfigurationState {
    baseFormCurrentValues: object;
    settingsFormCurrentValues: object;
    settingsFormIsValid: boolean;
}

const baseConfigInitialValues = {
    name: "",
    subsidiary: "",
    type: "",
};

const settingsPigBoomConfigInitialValues = {
    min_players: 4,
    contribution: 0.21,
    start_percentage: 0,
    prize_gold_value: 400,
    prize_silver_value: 300,
    prize_bronze_value: 200,
    prize_gold_frequency: 25,
    prize_silver_frequency: 50,
    prize_bronze_frequency: 25,
    time_wait_video: 1,
    pop_time: 15,
    min_pop_time: 5,
    time_eligible: 0,
    time_continue_eligible_bonus: 30,
    time_continue_eligible_game: 20,
    time_continue_eligible_extra: 30,
    show_eligible_bonus_icon: true,
    weight_coin_in: 1,
    percentage_terminal: 50,
    weight_total_bonus_win: 50,
    number_eligible_games: 0,
    hunter_draw_no_win: 2,
}

const settingsMrChampionConfigInitialValues = {
    min_players: 4,
    initial_value: 500,
    max_value: 9999,
    contribution: 0.5,
    min_sort: 400,
    max_sort: 1200,
    time_continue_eligible_bonus: 30,
    time_continue_eligible_game: 20,
    time_continue_eligible_extra: 30,
    weight_coin_in: 1,
    percentage_terminal: 50,
    weight_total_bonus_win: 50,
    hunter_draw_no_win: 2,
    notice_period: 30,
    count_down_period: 10
}

class SpecialPrizesPresetConfiguration extends Component<SpecialPrizesPresetConfigurationProps, SpecialPrizesPresetConfigurationState> {

    isDetail: boolean;
    isEdit: boolean;
    private generalError = ""

    constructor(props) {
        super(props);

        if (this.props.subsidiariesList.length == 0 && !this.props.subsidiariesLoading) {
            this.props.getSubsidiaries();
        }

        this.isDetail = this.props.match.path.includes("/detail");
        this.isEdit = this.props.match.path.includes("/edit");

        if (this.isDetail || this.isEdit) {
            if (!this.props.match.params["presetId"]) {
                this.cancelConfig()
            } else {
                this.props.getPreset(this.props.match.params["presetId"]);
            }
        }

        this.state = {
            baseFormCurrentValues: baseConfigInitialValues,
            settingsFormCurrentValues: {},
            settingsFormIsValid: false
        };
    }

    cancelConfig = () => {
        this.props.history.push(`/admin/special-prizes-presets`);
    };

    onChangeBaseForm = data => {
        if (data.values.type !== '' && data.values.type !== this.state.baseFormCurrentValues["type"]) {
            const settingsValues = data.values.type === 5
                ? settingsPigBoomConfigInitialValues
                : settingsMrChampionConfigInitialValues
            this.setState({settingsFormCurrentValues: settingsValues})
        }
        this.setState({baseFormCurrentValues: data.values});
    }

    onChangeSettingsForm = data => {
        if (this.state.baseFormCurrentValues["type"] === 6) {
            this.generalError = "";

            if (data.values['max_value'] < data.values['initial_value'] + data.values['min_sort']) {
                data.isValid = false
                this.generalError = "Maximum Value must be > or equal then Initial Value + Min. Sort."
            }
            if (data.values['max_value'] < data.values['initial_value'] + data.values['max_sort']) {
                data.isValid = false
                this.generalError = "Maximum Value must be > or equal then Initial Value + Max. Sort."
            }

        }
        this.setState({
            settingsFormCurrentValues: data.values,
            settingsFormIsValid: data.isValid
        });
    }

    submitPresetForm = () => {
        let baseEditingPreset = cloneDeep(this.state.baseFormCurrentValues)
        baseEditingPreset.settings = this.state.settingsFormCurrentValues

        if (this.isEdit) {
            baseEditingPreset.hasOwnProperty('id') && delete baseEditingPreset['id'];
            if (baseEditingPreset.hasOwnProperty('certified')) baseEditingPreset['certified'] = false;
        }

        this.props.addPreset({base: baseEditingPreset});
    };

    render() {
        if (
            this.props.subsidiariesList.length == 0 ||
            this.props.subsidiariesLoading ||
            this.props.presetLoading) {
            return (
                <div id="SpecialPrizesPresetConfiguration" className="visible">
                    <div className="loading" key="loading">
                        <Components.LoadingRipple width={100} height={100}/>
                    </div>
                </div>
            );
        } else if (
            (this.isDetail || this.isEdit) &&
            (Object.keys(this.props.initialPreset).length === 0)
        ) {
            return (
                <div id="SpecialPrizesPresetConfiguration" className="visible">
                    <div className="sidebar-layout">
                        <div className="container header" style={{textAlign: "end"}}>
                            <button onClick={this.cancelConfig}>
                                Cancel
                            </button>
                        </div>
                    </div>
                    <div className="error-config">
                        Special Prize Preset does not exist.
                    </div>
                </div>
            )
        }

        const isBaseFormValid =
            this.state.baseFormCurrentValues["name"] &&
            this.state.baseFormCurrentValues["name"] !== "" &&
            this.state.baseFormCurrentValues["subsidiary"] &&
            this.state.baseFormCurrentValues["subsidiary"] !== "" &&
            this.state.baseFormCurrentValues["type"] &&
            this.state.baseFormCurrentValues["type"] !== ""


        let typeSelectList = [
            {label: "Pig Boom", value: 5},
            {label: "Mr. Champion", value: 6}
        ]

        return (
            <div id="SpecialPrizesPresetConfiguration">
                <div className="sidebar-layout">
                    <div className="config-content">
                        <div className="container header">
                            <h1>
                                {this.isDetail
                                    ? `Preset ${this.state.baseFormCurrentValues["name"]} - Details`
                                    : "New Special Prize Preset"
                                }
                            </h1>
                            <button onClick={this.cancelConfig}>
                                Cancel
                            </button>
                        </div>
                        <div className={`container ${this.isDetail ? "readonly" : ""}`}>
                            <TransitionGroup>
                                <CSSTransition
                                    key={"preset-config"}
                                    timeout={600}
                                    classNames="fade-tabs"
                                >
                                    <div className="form-content">
                                        <div className="inner-card">
                                            <div className="inner-card-title">
                                                Base
                                                <span
                                                    className={`form-validation-icon ${isBaseFormValid
                                                        ? "valid"
                                                        : "invalid"
                                                    }`}
                                                >
                                                        <i className={`${isBaseFormValid
                                                            ? "icon-check-circle"
                                                            : "icon-times-circle-solid"}`}
                                                        />
                                                    </span>
                                            </div>
                                            <div className={`inner-card-content`}>
                                                <Form
                                                    key={`${this.state.baseFormCurrentValues["subsidiary"]}-${this.state.baseFormCurrentValues["type"]}`}
                                                    fields={baseConfigInitialFields(SubsidiaryUtils.subsidiarySelectItems(this.props.subsidiariesList), this.isEdit, typeSelectList)}
                                                    initialValues={this.isDetail || this.isEdit
                                                        ? this.props.initialPreset
                                                        : this.state.baseFormCurrentValues}
                                                    onChange={this.onChangeBaseForm}
                                                />
                                            </div>
                                        </div>
                                        {this.state.baseFormCurrentValues["type"] && (
                                            <div className="inner-card">
                                                <div className="inner-card-title">
                                                    Settings
                                                    <span
                                                        className={`form-validation-icon ${this.state.settingsFormIsValid
                                                            ? "valid"
                                                            : "invalid"
                                                        }`}
                                                    >
                                                        <i className={`${this.state.settingsFormIsValid
                                                            ? "icon-check-circle"
                                                            : "icon-times-circle-solid"}`}
                                                        />
                                                    </span>
                                                </div>
                                                <div className="inner-card-content sub-form">
                                                    {this.generalError && <div className="input-error" style={{
                                                        margin: '0px 8px'
                                                    }}>
                                                        <span
                                                            className="input-error-message"> {this.generalError} </span>
                                                    </div>}
                                                    <FormSelect
                                                        key={`${this.state.baseFormCurrentValues.hasOwnProperty("subsidiary")
                                                            ? this.state.baseFormCurrentValues["subsidiary"] + "_" + this.state.baseFormCurrentValues["type"]
                                                            : "settings"
                                                        }`}
                                                        fields={this.state.baseFormCurrentValues["type"] === 5
                                                            ? pigBoomFields()
                                                            : mrChampionFields()}
                                                        initialValues={this.isDetail || this.isEdit
                                                            ? this.props.initialPreset.settings
                                                            : this.state.settingsFormCurrentValues}
                                                        onChange={this.onChangeSettingsForm}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </CSSTransition>
                            </TransitionGroup>
                        </div>
                        {!this.isDetail && (
                            <div className={`navigation container`}>
                                <button
                                    className={`next ${this.props.submitPresetLoading
                                        ? "loading"
                                        : ""
                                    }`}
                                    disabled={
                                        !isBaseFormValid || !this.state.settingsFormIsValid
                                    }
                                    onClick={this.submitPresetForm}
                                >
                                    Create
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                {this.props.submittingPresetState && (
                    <Dialog
                        open={
                            this.props.submittingPresetState.error ==
                            false &&
                            this.props.submittingPresetState.success == true
                        }
                        onClose={() => {
                            this.props.clearSubmitPreset()
                        }}
                        onConfirm={() => {
                            this.props.clearPreset();
                            this.cancelConfig();
                        }}
                        addedClassName={"presets-success-dialog"}
                        confirmLabel={"Go to presets list"}
                        cancelLabel={"Review preset form"}
                    >
                        <img
                            src="/images/hurray.png"
                            width="268"
                            height="230"
                        />
                        <h2>Your preset is created!</h2>
                        <p>
                            Congratulations, your preset has been
                            successfully created. Thank you for your time!
                        </p>
                    </Dialog>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    subsidiariesList: specialPrizesPresetsStoreSelectors.subsidiariesList(state),
    subsidiariesLoading: specialPrizesPresetsStoreSelectors.subsidiariesLoading(state),
    presetLoading: specialPrizesPresetsStoreSelectors.presetLoading(state),
    initialPreset: specialPrizesPresetsStoreSelectors.initialPreset(state),
    submitPresetLoading: specialPrizesPresetsStoreSelectors.submitPresetLoading(state),
    submittingPresetState: specialPrizesPresetsStoreSelectors.submittingPresetState(state),
});

const mapDispatchToProps = {
    getSubsidiaries: SpecialPrizesPresetsActionCreators.getSubsidiaries,
    getPreset: SpecialPrizesPresetsActionCreators.getPreset,
    addPreset: SpecialPrizesPresetsActionCreators.addPreset,
    clearPreset: SpecialPrizesPresetsActionCreators.clearPreset,
    clearSubmitPreset: SpecialPrizesPresetsActionCreators.clearSubmitPreset,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SpecialPrizesPresetConfiguration));

